<template>
  <GenericWorkBoard platform="xhs" />
</template>
<script setup>
import GenericWorkBoard from './GenericWorkBoard.vue'
</script>
